import { CREATE_INITIATIVE_PRIVILEGES } from 'components/hooks/useEmployeeGoalsPrivileges';
import { useSelector } from 'react-redux';
import { initiativeDrawerSelector } from 'selectors/initiativeDrawer';

import { GOAL_VISIBILITY_OPTIONS } from 'constants/ProjectConstants';

// // Create
// CREATE_INITIATIVES(AccessControlMatrixType.GOALS),
// // View
// VIEW_COMMENT_PUBLIC_INITIATIVES(AccessControlMatrixType.GOALS),
// VIEW_COMMENT_ALL_INITIATIVES(AccessControlMatrixType.GOALS, Arrays.asList(
//     VIEW_COMMENT_PUBLIC_INITIATIVES)),
// // Update status progress
// UPDATE_PUBLIC_INITIATIVE_STATUS_PROGRESS(AccessControlMatrixType.GOALS, Arrays.asList(
//     VIEW_COMMENT_PUBLIC_INITIATIVES)),
// UPDATE_ALL_INITIATIVE_STATUS_PROGRESS(AccessControlMatrixType.GOALS, Arrays.asList(
//     VIEW_COMMENT_PUBLIC_INITIATIVES,
//     VIEW_COMMENT_ALL_INITIATIVES,
//     UPDATE_PUBLIC_INITIATIVE_STATUS_PROGRESS)),
// // Edit
// EDIT_PUBLIC_INITIATIVE(AccessControlMatrixType.GOALS, Arrays.asList(
//     VIEW_COMMENT_PUBLIC_INITIATIVES,
//     UPDATE_PUBLIC_INITIATIVE_STATUS_PROGRESS)),
// EDIT_ALL_INITIATIVE(AccessControlMatrixType.GOALS, Arrays.asList(
//     VIEW_COMMENT_PUBLIC_INITIATIVES,
//     VIEW_COMMENT_ALL_INITIATIVES,
//     UPDATE_PUBLIC_INITIATIVE_STATUS_PROGRESS,
//     UPDATE_ALL_INITIATIVE_STATUS_PROGRESS,
//     EDIT_PUBLIC_INITIATIVE)),
// // Delete
// DELETE_PUBLIC_INITIATIVE(AccessControlMatrixType.GOALS, Arrays.asList(
//     VIEW_COMMENT_PUBLIC_INITIATIVES)),
// DELETE_ALL_INITIATIVE(AccessControlMatrixType.GOALS, Arrays.asList(
//     VIEW_COMMENT_PUBLIC_INITIATIVES,
//     VIEW_COMMENT_ALL_INITIATIVES,
//     DELETE_PUBLIC_INITIATIVE)),

export const VIEW_AND_COMMENT_INITIATIVE_PRIVILEGES = {
  VIEW_COMMENT_PUBLIC_INITIATIVES: 'VIEW_COMMENT_PUBLIC_INITIATIVES',
  VIEW_COMMENT_ALL_INITIATIVES: 'VIEW_COMMENT_ALL_INITIATIVES',
};

export const EDIT_INITIATIVE_PRIVILEGES = {
  EDIT_ALL_INITIATIVE: 'EDIT_ALL_INITIATIVE',
  EDIT_PUBLIC_INITIATIVE: 'EDIT_PUBLIC_INITIATIVE',
};
export const UPDATE_INITIATIVE_PROGRESS_PRIVILEGES = {
  UPDATE_PUBLIC_INITIATIVE_STATUS_PROGRESS: 'UPDATE_PUBLIC_INITIATIVE_STATUS_PROGRESS',
  UPDATE_ALL_INITIATIVE_STATUS_PROGRESS: 'UPDATE_ALL_INITIATIVE_STATUS_PROGRESS',
};

export const DELETE_INITIATIVE_PRIVILEGES = {
  DELETE_ALL_INITIATIVE: 'DELETE_ALL_INITIATIVE',
  DELETE_PUBLIC_INITIATIVE: 'DELETE_PUBLIC_INITIATIVE',
};

export const useInitiativeAccessControl = () => {
  const { accessPrivileges, visibilityType } = useSelector(initiativeDrawerSelector);

  const accessPrivilegesList = Array.isArray(accessPrivileges) ? accessPrivileges.map(({ name }) => name) : [];

  // IF AN INITIATIVE CAN BE EDITED OR NOT
  const canEditInitiativePrivilege =
    visibilityType === GOAL_VISIBILITY_OPTIONS[1].value // THIS MEANS IF TYPE IS PUBLIC
      ? accessPrivilegesList.includes(EDIT_INITIATIVE_PRIVILEGES.EDIT_PUBLIC_INITIATIVE)
      : accessPrivilegesList.includes(EDIT_INITIATIVE_PRIVILEGES.EDIT_ALL_INITIATIVE);

  // IF AN INITIATIVE CAN BE CREATED OR NOT
  const canCreateInitiativePrivilege = accessPrivilegesList.includes(CREATE_INITIATIVE_PRIVILEGES.CREATE_INITIATIVES);

  // IF AN INITIATIVE STATUS CAN BE UPDATED OR NOT
  const canUpdateInitiativeProgressPrivilege =
    visibilityType === GOAL_VISIBILITY_OPTIONS[1].value
      ? accessPrivilegesList.includes(UPDATE_INITIATIVE_PROGRESS_PRIVILEGES.UPDATE_PUBLIC_INITIATIVE_STATUS_PROGRESS)
      : accessPrivilegesList.includes(UPDATE_INITIATIVE_PROGRESS_PRIVILEGES.UPDATE_ALL_INITIATIVE_STATUS_PROGRESS);

  // IF AN INITIATIVE STATUS CAN BE DELETED OR NOT
  const canDeleteInitiativePrivilege =
    visibilityType === GOAL_VISIBILITY_OPTIONS[1].value
      ? accessPrivilegesList.includes(DELETE_INITIATIVE_PRIVILEGES.DELETE_PUBLIC_INITIATIVE)
      : accessPrivilegesList.includes(DELETE_INITIATIVE_PRIVILEGES.DELETE_ALL_INITIATIVE);

  // IF A PERSON CAN COMMENT ON AN INITIATIVE OR NOT
  const canViewAndCommentInitiativePrivilege =
    visibilityType === GOAL_VISIBILITY_OPTIONS[1].value
      ? accessPrivilegesList.includes(VIEW_AND_COMMENT_INITIATIVE_PRIVILEGES.VIEW_COMMENT_PUBLIC_INITIATIVES)
      : accessPrivilegesList.includes(VIEW_AND_COMMENT_INITIATIVE_PRIVILEGES.VIEW_COMMENT_ALL_INITIATIVES);

  return {
    canEditInitiativePrivilege,
    canUpdateInitiativeProgressPrivilege,
    canDeleteInitiativePrivilege,
    canViewAndCommentInitiativePrivilege,
    canCreateInitiativePrivilege,
  };
};
